import defaultTheme from "./clients/defaultTheme";
import ouiTheme from "./clients/ouiTheme";

const Themes = {
  default: defaultTheme,
  "oui-investimentos": ouiTheme,
};

export default Themes;
